import { cva } from 'class-variance-authority';

export const baseTickerVariants = cva(
  'c-ticker',
  {
    variants: {
      size: {
        large: 'c-ticker--large',
        small: 'c-ticker--small',
      },
      reversed: {
        true: 'c-ticker--reversed',
      },
      mobile: {
        true: 'c-ticker--mobile',
      },
    },
    defaultVariants: {
      size: 'large',
      mobile: false,
    },
  },
);
